import * as storage from './storage.js';

export const setAuthObj = async (payload) => {
    await storage.set(storage.KEYS.LOGIN_TOKEN, payload.token);
    await storage.set(storage.KEYS.USERNAME, payload.username);
    await storage.set(storage.KEYS.AUTH_OBJ, JSON.stringify(payload));
};

export const emptyAuthObj = async () => {
    await storage.remove(storage.KEYS.LOGIN_TOKEN);
    await storage.remove(storage.KEYS.USERNAME);
    await storage.remove(storage.KEYS.AUTH_OBJ);
};
